import React, { Component } from "react";
import NavBar from "./navbar";
import Section1 from "./manage-section1";
import Section2 from "./manage-section2";
import Section3 from "./manage-section3";
import MySwiper from "./manage-swiper";
import Footer from "./footer";
import "./manage.css";

class HomePage extends Component {
  render() {
    return (
      <div>
        <div className="main-container">
          <span className="bubble" />
          <div className="wrapper-container">
            <NavBar />
            <Section1 />
            <Section2 />
            <div className="swiper-section">
              <p className="swiper-header"> What they've said</p>
              <MySwiper />
            </div>
          </div>
          <span className="bubble2" />
        </div>
        <Section3 />
        <Footer />
      </div>
    );
  }
}

export default HomePage;
